import Cookies from 'universal-cookie';
import randomstring from 'randomstring';
import {saveAs} from 'file-saver';
import { SERVER } from '../const/networkUrls';
import {parse} from 'date-fns';
import { isNullOrUndefined } from 'util';
import config from '../const/config';

const cookies = new Cookies();

const redirectToLogin = () => {
    let url = SERVER.loginUrl;
    window.location = url;
}

const redirectToAuth = () => {
    let stateValue = randomstring.generate(13);
    localStorage.setItem("stateVal", stateValue);
    let url = SERVER.SERVICES.redirectUrl + stateValue;
    window.location = url;
}

export const isValueNullOrUndefinedOrEmpty = (value) => {
    if(value === undefined || value === null)
    {
        return true;
    }
    else if(typeof(value) === 'string')
    {
        return value.trim() == "";  
    }
    return false;
}

export const IsUnauthorized = (error) => {
    if( error && error.response && error.response.data && error.response.data.status === 401 ) {
        clearCookiesStorageAndRedirect(false);
    }
}

export function getTwoDigitMonth(date) {
    return ("0" + (parse(date, "dd/MM/yyyy", new Date()).getMonth() + 1)).slice(-2);
}

export function getYear(date) {
    return parse(date, "dd/MM/yyyy", new Date()).getFullYear();
}

export const isEmptyObject = (obj) => {
    return !obj || Object.keys(obj).length === 0;
}

export const clearCookiesStorageAndRedirect = (isLogin) => {
    const cookieToken = cookies.get("token");
    cookies.remove('token', { path: '/' });
    localStorage.removeItem('isAuth');
    localStorage.removeItem('IsAuthURL');
    localStorage.removeItem('stateVal');
    localStorage.removeItem('rftValue');
    localStorage.removeItem('isLoading');
    localStorage.clear();

    if (isLogin) {
        redirectToAuth();
    } else {
        if(cookieToken && cookieToken.identityToken && cookieToken.identityToken.trim() !=="") {
            const logoutUrl = `${SERVER.SERVICES.logoutUrl}?post_logout_redirect_uri=${SERVER.loginUrl}/&id_token_hint=${cookieToken.identityToken}`;
            window.location.replace(logoutUrl, "log out");
        } else {
            redirectToLogin();
        }
    }
}

export const downloadMonthlyIntakeBookHandler = async (contractCode, revenueDate,
    userIntakeBookFileName, intakeBookFileName, setErrorOrWarningHandler, ShowOrHideLoader, downloadMonthlyIntakeBook) => {

    if(isValueNullOrUndefinedOrEmpty(userIntakeBookFileName)) {
        setErrorOrWarningHandler(true, "cashregisternotfound", "false", "CashRegister", true, false, false);
    }                                     
    else {
        ShowOrHideLoader(true);
        await downloadMonthlyIntakeBook(contractCode, revenueDate)    
        .then((data)=>{
            ShowOrHideLoader(false);
            saveAs(new Blob([data]), userIntakeBookFileName);
        })
        .catch((error)=>{
            setErrorOrWarningHandler(true, "wentwrong", "false", "CashRegister", true, false, false);
        })     
    }
}



export const formattedRevenueAmountValues = (d) => {
    return {
        ...d.revenueAmount,
        tax_0: ((isNullOrUndefined(d.revenueAmount.tax_0) || d.revenueAmount.tax_0 === "" || d.revenueAmount.tax_0 === -1) && (!d.isSubmitted || !d.isMonthlySubmitted || d.isChangeRequestAllowed)) ? "" : (d.revenueAmount.tax_0).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        tax_6: ((isNullOrUndefined(d.revenueAmount.tax_6) || d.revenueAmount.tax_6 === "" || d.revenueAmount.tax_6 === -1) && (!d.isSubmitted || !d.isMonthlySubmitted || d.isChangeRequestAllowed))? "" : (d.revenueAmount.tax_6).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        tax_12: ((isNullOrUndefined(d.revenueAmount.tax_12) || d.revenueAmount.tax_12 === "" || d.revenueAmount.tax_12 === -1) && (!d.isSubmitted || !d.isMonthlySubmitted || d.isChangeRequestAllowed))? "" : (d.revenueAmount.tax_12).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        tax_21: ((isNullOrUndefined(d.revenueAmount.tax_21) || d.revenueAmount.tax_21 === "" || d.revenueAmount.tax_21 === -1) && (!d.isSubmitted || !d.isMonthlySubmitted || d.isChangeRequestAllowed))? "" : (d.revenueAmount.tax_21).toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
}

export const formattedSoldTicketValue = (d) => {
    return ((isNullOrUndefined(d.soldTicket) || d.soldTicket === "" || d.soldTicket === -1) && (!d.isSubmitted || !d.isMonthlySubmitted || d.isChangeRequestAllowed))? "" : d.soldTicket.toLocaleString('nl-BE')
}

export const sortDate = (a, b, order) => {
    if (order === 'desc') {
      return parse(b, "dd/MM/yyyy", new Date()) - parse(a, "dd/MM/yyyy", new Date());
    }
   
    return parse(a, "dd/MM/yyyy", new Date()) - parse(b, "dd/MM/yyyy", new Date()); // desc
}
export const getSelectedContractIds = (overview) => {
    const ids = overview && overview.reduce((arr, item, index) => {
        item.contractDetails.map(d => {
            if (d.isChecked && !arr.includes(Number(d.contractId))) {
                arr.push(Number(d.contractId));
                return d.contractId;
            }
        });
        return arr
    }, []);

    return ids;
}

export const getSelectedBusinessPartnerIds = (overview) => {
    let ids = overview && overview.reduce((arr, item, index) => {
        item.contractDetails.map(d => {
            if (d.isChecked && !arr.includes(item.businessPartnerId)) {
                arr.push(item.businessPartnerId);
                return item.businessPartnerId
            }
        });
        return arr
    }, []);

    return ids;
}

export const getMonthAndYearOnlyByDate = (d) => {
    return d && (getTwoDigitMonth(d) + "/" + getYear(d))
}


export const checkIfNullOrUndefined = (fieldValue) => {
    return isNullOrUndefined(fieldValue) || fieldValue === "";
}

export const checkIfAmountIsZero = (amountValue) => {
    return amountValue!=="" && amountValue !== "0" && amountValue !== "0,00"
}

export const setBorder = (columnName, rowIndex, className, isAdd) => {
    const id= "#"+columnName+"_"+rowIndex;
    let idSelector=document.querySelector(id);
    if(idSelector && idSelector.classList) {
        isAdd ? idSelector.classList.add(className) : idSelector.classList.remove(className)
    }
}

export const isInvalidValueExistsInRow = (rowToCheck, checkType) => {
    if(checkType === "fieldexceeding") {

        return isMoreThanMaxValue(rowToCheck.revenueAmount.tax_0) ||
        isMoreThanMaxValue(rowToCheck.revenueAmount.tax_6) ||
        isMoreThanMaxValue(rowToCheck.revenueAmount.tax_12) ||
        isMoreThanMaxValue(rowToCheck.revenueAmount.tax_21) ||
        isMoreThanMaxValue(rowToCheck.soldTicket)
    }
    else if(checkType === "validdata") {

        return isInvalidDecimal(rowToCheck.revenueAmount.tax_0) ||
        isInvalidDecimal(rowToCheck.revenueAmount.tax_6) ||
        isInvalidDecimal(rowToCheck.revenueAmount.tax_12) ||
        isInvalidDecimal(rowToCheck.revenueAmount.tax_21) ||
        isInvalidDecimal(rowToCheck.soldTicket)
    }
    else{

        return isMoreThanMaxValue(rowToCheck.revenueAmount.tax_0) || isInvalidDecimal(rowToCheck.revenueAmount.tax_0) ||
        isMoreThanMaxValue(rowToCheck.revenueAmount.tax_6) || isInvalidDecimal(rowToCheck.revenueAmount.tax_6) ||
        isMoreThanMaxValue(rowToCheck.revenueAmount.tax_12) || isInvalidDecimal(rowToCheck.revenueAmount.tax_12) ||
        isMoreThanMaxValue(rowToCheck.revenueAmount.tax_21) || isInvalidDecimal(rowToCheck.revenueAmount.tax_21) ||
        isMoreThanMaxValue(rowToCheck.soldTicket) || isInvalidDecimal(rowToCheck.soldTicket)
    }
}

export const isMoreThanMaxValue = (maxValueField) => {
    const maxvalue = config.maxfieldvalue;
    return maxValueField && Number(maxValueField) >= 0 && convertToNumber(maxValueField) > maxvalue ;
}

export const isInvalidDecimal = (value) => {
    if(value && Number(value) >= 0) {
        let decimalValue = value.split(",");
        return decimalValue.length > 1 && decimalValue[1].length !== 2 ? true : false;
    }
    return false;
}


export const convertToNumber = (value) => {
    return Number(value.replace(/\./g, "").replace(/\,/g, "."))
}

export const findUnique = (arr, predicate) => {
    var found = {};
    arr.forEach(d => {
      found[predicate(d)] = d;
    });
    return Object.keys(found).map(key => found[key]);
}




